import React from 'react'
import { getDateFormated } from '../../../../js/helper'
import Typography from '@material-ui/core/Typography'


const ConnectedEvents = ({event, classes}) =>{
    return (
        <div className={`${classes.canidate} ${classes.connected}`}>
        <Typography className={classes.canidate.lable} color='inherit' variant='body1'>
            Angbot wurde noch nicht bestätigt
        </Typography>
        <Typography className={classes.canidate.name} color='inherit' variant='subheading'>
            {event.canidate.name}
        </Typography>
        <Typography className={classes.canidate.lable} color='inherit' variant='body1'>
            Vermittelt am: {getDateFormated(event.admin.timeStamp, 'normal')} {getDateFormated(event.admin.timeStamp, 'untilThen')}
        </Typography>
    </div>
    )
}

export default ConnectedEvents


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/View/ConnectedEvents.js